const DEFAULT_INITIAL = 'D';

export type AvatarThemeType = {
  background: string;
  color: string;
};

export const avatarThemes: Array<AvatarThemeType> = [
  {
    background: '#008296',
    color: '#FFFFFF',
  }, //dark theme
  {
    background: '#667575',
    color: '#FFFFFF',
  }, //dark theme
  {
    background: '#E3ECED',
    color: '#006878',
  },
  {
    background: '#538000',
    color: '#FFFFFF',
  },
  {
    background: '#002F36',
    color: '#FFFFFF',
  }, //dark theme
  {
    background: '#008296',
    color: '#FFFFFF',
  },
  {
    background: '#FF8F00',
    color: '#002F36',
  },
  {
    background: '#CC0C39',
    color: '#FFFFFF',
  },
];

/**
 * This method is responsible for returning the initials of the full name.
 * A max of 2 characters will be returned as initials.
 * Cases:
 * 1. Full Name: Neil, return N
 * 2. Full Name: Neil Walker, return NW
 * 3. Full Name: Fred Mayer Walker, return FW
 * @param name full name ex: Neil Walker
 * @returns initials eg: NK
 */
export const getInitials = (name: string) => {
  if (!name) {
    return DEFAULT_INITIAL;
  }
  let initials = '';
  const nameList = name.split(' ');
  if (nameList.length >= 1) {
    initials = nameList[0].charAt(0);
  }
  if (nameList.length > 1) {
    initials += nameList[nameList.length - 1].charAt(0);
  }
  return initials.toUpperCase();
};

/**
 * Selects a theme based on the charCode.
 * index will always fall within [0 - (avatarThemes.length -1)]
 * @param initials
 * @returns theme
 */
export const selectTheme = (initials: string): AvatarThemeType => {
  const totalCharCode = charCode(initials);

  const index = totalCharCode % avatarThemes.length;
  return avatarThemes[index];
};

/**
 * Calculates the total charCode for a string.
 * @param astring the string for which charCode will be calculated
 * @returns total charCode for the string
 */
export const charCode = (astring: string): number => {
  if (!astring) {
    return 0;
  }
  let totalCharCode = 0;
  for (let i = 0; i < astring.length; i++) {
    totalCharCode += astring[i].charCodeAt(0);
  }
  return totalCharCode;
};
